export default "__VITE_ASSET__DcjGyuW$__"